/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setPainScaleOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getPainScale() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const painScaleResponse = yield call([vitalsService, vitalsService.getPainScale])
    const { entity } = painScaleResponse
    yield put(setPainScaleOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPainScale() error: ${e}`))
  }
}

export function* getPainScaleSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPainScale)
}
